import { Stack } from '@datastructures-js/stack';

export class ReferencesHistoryService {
    private static instance: ReferencesHistoryService;

    private dataPrevStack = new Stack<ReferencesHistoryData>();
    private dataNextStack = new Stack<ReferencesHistoryData>();
    private _currentReferenceData! : ReferencesHistoryData;
    private currentDataSet = false;

    private ReferencesHistoryService() {
        // Empty private constructor to implement singleton
    }

    public static getInstance(): ReferencesHistoryService {
        if (!ReferencesHistoryService.instance) {
            ReferencesHistoryService.instance = new ReferencesHistoryService();
        }

        return ReferencesHistoryService.instance;
    }

    public currentReferenceData(value: ReferencesHistoryData) {
        this.currentDataSet = true;
        this._currentReferenceData = value;
    }
    public addToHistory(referencesHistoryData: ReferencesHistoryData) : ReferencesHistoryData {
        if (this._currentReferenceData && (this.dataPrevStack.isEmpty() || this.dataPrevStack.peek().articleId !== this._currentReferenceData.articleId)) {
            this.dataPrevStack.push(this._currentReferenceData);
        }
        this.currentReferenceData(referencesHistoryData);
        this.dataNextStack.clear();
        return referencesHistoryData;
    }

    public getNext() : ReferencesHistoryData | null {
        if (this.dataNextStack.isEmpty()) {
            return null;
        } else {
            if (this._currentReferenceData) {
                this.dataPrevStack.push(this._currentReferenceData)
            }
            this.currentReferenceData(this.dataNextStack.pop());
            return this._currentReferenceData;
        }

    }

    public getPrev() : ReferencesHistoryData | null {
        if (this.dataPrevStack.isEmpty()) {
            return null;
        } else {
            if (this._currentReferenceData) {
                this.dataNextStack.push(this._currentReferenceData)
            }
            this.currentReferenceData(this.dataPrevStack.pop());
            return this._currentReferenceData;
        }
    }

    public peakPrev() : ReferencesHistoryData {
        return this.dataPrevStack.peek();
    }

    public peakNext() : ReferencesHistoryData  {
        return this.dataNextStack.peek();
    }

    public isCurrentAvailable() : boolean {
        return this.currentDataSet;
    }

    public isPrevAvailable() : boolean {
        return !this.dataPrevStack.isEmpty();
    }

    public isNextAvailable() : boolean {
        return !this.dataNextStack.isEmpty();
    }
}

export interface ReferencesHistoryData {
    bookCode?: string,
    bookDescription?: string,
    articleId?: string,
    articleDescription?: string,
    searchTerm?: string,
}